const NO_SORT_KEYS = ["operations", "operation", "oper", "project_img", "answer"];
const NO_TIP_KEYS = ["operations", "operation", "oper", "project_img"];

function colKey(col) {
  return (col && (col.prop || col.key || col.value)) || "";
}

export function listSortable(col) {
  const key = colKey(col);
  if (!key || NO_SORT_KEYS.includes(key)) {
    return false;
  }
  return true;
}

export function listColProp(col) {
  const key = colKey(col);
  return key || undefined;
}

export function listOverflow(col) {
  const key = colKey(col);
  if (!key || NO_TIP_KEYS.includes(key)) {
    return false;
  }
  return col.overflow !== false;
}

export function listColWidth(col) {
  const key = colKey(col);
  if (!["operations", "operation", "oper"].includes(key)) {
    return undefined;
  }
  const n = col && col.width ? parseInt(String(col.width), 10) : 0;
  if (n > 40) {
    return n;
  }
  return 160;
}

export function listColMinWidth(col) {
  const key = colKey(col);
  if (["operations", "operation", "oper"].includes(key)) {
    const n = col && col.width ? parseInt(String(col.width), 10) : 0;
    if (n > 40) {
      return n;
    }
    return 160;
  }
  if (
    key === "project_name" ||
    key === "name" ||
    key === "menu_name" ||
    key === "title"
  ) {
    return 220;
  }
  if (key && key.indexOf("time") > -1) {
    return 168;
  }
  if (col && col.width) {
    const n = parseInt(String(col.width), 10);
    return n > 0 ? Math.max(n, 96) : 108;
  }
  return 108;
}

export function listColClass(col) {
  const key = colKey(col);
  if (["operations", "operation", "oper"].includes(key)) {
    return "table-ops-cell";
  }
  return "";
}

export function listColFixed(col) {
  const key = colKey(col);
  if (["operations", "operation", "oper"].includes(key)) {
    return "right";
  }
  return undefined;
}
